import axios from "axios";

export const httpCore = axios.create({
  baseURL: "http://127.0.0.1:8000/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

export const httpPatients = axios.create({
  baseURL: "http://127.0.0.1:8000/api/patients/",
  headers: {
    "Content-Type": "application/json",
  },
});